export const BaseUrl = "https://acharya-electric.onrender.com/api";
// export const BaseUrl = "http://localhost:80/api";
